'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'diamond';
var width = 576;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M27.3 267.3L16 256 288-16 299.3-4.7 548.7 244.7 560 256 288 528 276.7 516.7 27.3 267.3zM38.6 256L288 505.4 537.4 256 288 6.6 38.6 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;